import axios from 'axios';
import { getStoredAuthToken } from '../authSession';

function setupAxiosInterceptor() {
  axios.interceptors.request.use(
    (config) => {
      const token = getStoredAuthToken();
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

export default setupAxiosInterceptor;
